import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, tabletCSS } from '@measures/responsive'
import { StyledBundlingHeader as BundlingHeaderWrapper } from '@components/Bundling/Header'

interface BundlingWrapperProps {
  children?: React.ReactNode
  accentColor?: string
  hasTitle?: boolean
  hasLinkInTitle?: boolean
}

type StyledBundlingWrapperProps = Pick<
  BundlingWrapperProps,
  'accentColor' | 'hasTitle' | 'hasLinkInTitle'
>

const StyledBundlingWrapper = styled.div<StyledBundlingWrapperProps>`
  ${({
    theme: {
      colors: { staticRed500 },
      measures: {
        stretchWidth,
        outerPadding: { mobile: mobilePadding, desktop: desktopPadding },
      },
      spacing: { spacing32, spacing16 },
    },
    accentColor,
    hasTitle,
    hasLinkInTitle,
  }) => css`
    display: grid;
    align-items: flex-start;
    grid-template-columns: minmax(0, 1fr);

    ${desktopCSS(css`
      grid-column-gap: ${spacing32};
      grid-template-columns: repeat(12, minmax(0, 1fr));
    `)};

    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      ${hasTitle &&
      css`
        top: ${hasLinkInTitle ? '47px' : '42px'};
      `}
      left: 0;
      z-index: 3;
      width: calc(100% + 2 * ${mobilePadding});
      ${stretchWidth()};
      ${tabletCSS(css`
        width: calc(100% + ${spacing16});
        margin-left: -${spacing16};
        margin-right: 0;
      `)}
      ${desktopCSS(css`
        width: calc(100% + 2 * ${desktopPadding});
      `)};
      height: 24px;
      background-color: ${accentColor ?? staticRed500};
      clip-path: polygon(0 0, 100% 0, 0 100%);
    }

    ${BundlingHeaderWrapper} {
      ${desktopCSS(css`
        grid-column: 1 / -1;
      `)};
    }
  `}
`

const OuterWrapper: FunctionComponent<BundlingWrapperProps> = ({
  children,
  accentColor,
  hasTitle,
  hasLinkInTitle,
}) => {
  return (
    <StyledBundlingWrapper
      accentColor={accentColor}
      hasTitle={hasTitle}
      hasLinkInTitle={hasLinkInTitle}
    >
      {children}
    </StyledBundlingWrapper>
  )
}

export default OuterWrapper
